import { userInfoStore } from '../../../store/userInfoStore';
import { kenoBetsStore } from '../kenoStore/betStore';
import { autoBetStore } from '../../../store/autoBetStore';
import { checkHashStore } from '../../../store/checkHashStore';
import { ValidationType } from '../../../core/constants/validationType';
import { KENO_NUMBERS_ANIMATION_DURATION } from '../kenoCore/constants';
import { userSettingsStore } from '../../../store/userSettingsStore';
import { betHistoryStore } from '../../../store/betHistoryStore';
import { notificationStore } from '../../../store/notificationStore';
import { soundService } from '../../../services/baseSoundService/soundService';
import { KenoSoundsName } from '../kenoCore/constants/sounds';
import { liveUpdateStore } from '../../../store/liveUpdateStore';
import { THIS_GAMES_COLUMN_ID } from '../../../core/constants/liveBetsContants';
import { mainGameConnection } from '../../../core/mainGameConnection/mainGameConnection';
import { freeBetStore } from '../../../store/freeBetStore';

class KenoGameService {
  onGetInitialStateResult({ maxWinLimit, lastSpinInfo, additionalInfo }) {
    this.resetGameStoreData();
    if (lastSpinInfo) {
      checkHashStore.setLastRoundInfo(lastSpinInfo);
      checkHashStore.setLastRoundResult({
        spinNumbers: lastSpinInfo.spinNumbers,
        resultNumbers: lastSpinInfo.resultNumber,
        id: lastSpinInfo.id,
        time: lastSpinInfo.date,
      });
    }
    kenoBetsStore.setMaxWinLimit(maxWinLimit);
    kenoBetsStore.setKenoOddsByRiskType(additionalInfo.cardOddsDic);

    liveUpdateStore.setSelectedColumn(THIS_GAMES_COLUMN_ID);
  }

  doSpin() {
    if (autoBetStore.isAutoBetOn && !autoBetStore.isAutoBetStart) {
      autoBetStore.setIsAutoBetStart(true);
    }
    if (kenoBetsStore.isBetsClosed) {
      return;
    }
    soundService.play(KenoSoundsName.bet);
    const model = {
      spinData: {
        amount: userInfoStore.betAmount,
        riskType: kenoBetsStore.selectedRiskType,
        numbers: kenoBetsStore.selectedNumbers,
      },
      isAutoPlay: autoBetStore.isAutoBetOn,
      isTurbo: userSettingsStore.isTurboOn,
    };
    kenoBetsStore.setIsBetsClosed(true);
    mainGameConnection.doSpin(model);
  }

  handleDoSpinResult({
    responseCode,
    winAmount,
    result,
    odd,
    date,
    newHash,
    hash,
    key,
    salt,
    id,
    balance,
  }) {
    if (responseCode === ValidationType.Success) {
      const { resultNumber } = result;
      if (!freeBetStore.currentFreeBet) {
        userInfoStore.setUserBalance(balance);
      }
      kenoBetsStore.setIsRoundStart(true);
      if (autoBetStore.isAutoBetStart) {
        autoBetStore.setAutoBetCount(autoBetStore.autoBetCount - 1);
      }
      if (userSettingsStore.isTurboOn) {
        kenoBetsStore.setWinNumbers(resultNumber);
        setTimeout(() => {
          kenoBetsStore.setWinAmount(winAmount);
          kenoBetsStore.setWinOdd(odd);
          kenoBetsStore.updateLastResultOdd({ odd, isWin: Boolean(winAmount), id: Date.now() });
          if (winAmount) {
            soundService.play(KenoSoundsName.win);
          }
          setTimeout(
            () => {
              this.resetGameStoreData();
            },
            winAmount ? 1000 : 0
          );
        }, KENO_NUMBERS_ANIMATION_DURATION / 2);
      } else {
        this.animateWinNumbers({ resultNumber, winAmount, odd });
      }
      checkHashStore.setLastRoundInfo({ salt, key, hash });
      checkHashStore.setNextRoundHash(newHash);
      checkHashStore.setLastRoundResult({
        spinNumbers: kenoBetsStore.selectedNumbers,
        resultNumbers: resultNumber,
        id,
        time: date,
      });
    } else {
      notificationStore.setNotification(responseCode);
      if (autoBetStore.isAutoBetStart) {
        autoBetStore.resetAutoBetState();
      }
      kenoBetsStore.setIsBetsClosed(false);
    }
  }

  animateWinNumbers({ resultNumber, winAmount, odd }) {
    resultNumber.forEach((winNumber, index) => {
      setTimeout(() => {
        if (kenoBetsStore.selectedNumbers.includes(winNumber)) {
          soundService.play(KenoSoundsName.matching);
        } else {
          soundService.play(KenoSoundsName.noMatching);
        }
        kenoBetsStore.updateWinNumbers(winNumber);
      }, (KENO_NUMBERS_ANIMATION_DURATION / resultNumber.length) * (index + 1));
    });
    setTimeout(() => {
      kenoBetsStore.setWinAmount(winAmount);
      kenoBetsStore.setWinOdd(odd);
      if (winAmount) {
        soundService.play(KenoSoundsName.win);
      }
      kenoBetsStore.updateLastResultOdd({ odd, isWin: Boolean(winAmount), id: Date.now() });
      setTimeout(
        () => {
          this.resetGameStoreData();
        },
        winAmount ? 1000 : 0
      );
    }, KENO_NUMBERS_ANIMATION_DURATION + KENO_NUMBERS_ANIMATION_DURATION / 2);
  }

  resetGameStoreData() {
    kenoBetsStore.setIsBetsClosed(false);
    if (!autoBetStore.autoBetCount && autoBetStore.isAutoBetOn && autoBetStore.isAutoBetStart) {
      autoBetStore.resetAutoBetState();
    }
    if (autoBetStore.autoBetCount && autoBetStore.isAutoBetOn) {
      this.doSpin();
    }
    kenoBetsStore.setIsRoundStart(false);
    betHistoryStore.getLastBet();
    kenoBetsStore.setWinNumbers([]);
    userInfoStore.getBalance();
    kenoBetsStore.setWinAmount(0);
    kenoBetsStore.setWinOdd(0);
  }
}

export const kenoGameService = new KenoGameService();
